/**
 * calculator-tco.js
 *
 * Interfața interactivă. NU conține formule, doar controale și randare.
 * Toate calculele vin din TCOModel (assets/tco-model.js), care e sursa de adevăr.
 *
 * Principiu: tabelul randat server-side NU se dublează. JS îl actualizează
 * pe loc, prin ancorele data-tco-*. Așa nu există două variante de conținut,
 * iar ce vede motorul de căutare e exact ce vede omul.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-tco-app]');
  if (!root || !window.TCOModel || !window.TCODate) return;

  var M = window.TCOModel;
  var D = window.TCODate;

  var nf0 = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 });
  var nf1 = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 1 });
  var nf2 = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 });

  function ron(v) { return nf0.format(Math.round(v)); }
  function aniTxt(n) { return n + (n === 1 ? ' an' : ' ani'); }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var state = {
    kmAn: D.IPOTEZE.kmAn,
    ani: D.IPOTEZE.ani,
    eur: D.IPOTEZE.eur,
    prosumer: D.IPOTEZE.prosumer,
    sortBy: 'total',
    cars: D.PRESETS.map(clone)
  };

  /* ---------- definiția controalelor globale ---------- */

  var GLOBALE = [
    { key: 'kmAn', et: 'Kilometri pe an', unit: 'km', min: 0, max: 1000000, step: 1000, clamp: true },
    { key: 'ani', et: 'Ani de deținere', unit: 'ani', min: 1, max: 30, step: 1, clamp: true },
    { key: 'eur', et: 'Curs EUR → RON', unit: 'lei', min: 3, max: 8, step: 0.05, ajutor: D.TEXTE.eur }
  ];

  /* ---------- construirea controalelor ---------- */

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function butonAjutor(wrap, et, text) {
    var h = el('button', 'tcoc-help', '?');
    h.type = 'button';
    h.title = text;
    h.setAttribute('aria-label', 'Explicație pentru ' + et);
    h.addEventListener('click', function () {
      var nota = wrap.querySelector('.tcoc-help-text');
      if (nota) { nota.remove(); return; }
      wrap.appendChild(el('p', 'tcoc-help-text', text));
    });
    return h;
  }

  function campGlobal(c) {
    var wrap = el('div', 'tcoc-field');
    var lab = el('label', 'tcoc-label');
    lab.setAttribute('for', 'tcoc-' + c.key);
    lab.appendChild(el('span', 'tcoc-label-text', c.et));
    if (c.unit) lab.appendChild(el('span', 'tcoc-unit', c.unit));
    if (c.ajutor) lab.appendChild(butonAjutor(wrap, c.et, c.ajutor));
    wrap.appendChild(lab);

    var inp = document.createElement('input');
    inp.type = 'number';
    inp.className = 'tcoc-input';
    inp.id = 'tcoc-' + c.key;
    inp.value = state[c.key];
    if (c.min != null) inp.min = c.min;
    if (c.max != null) inp.max = c.max;
    if (c.step != null) inp.step = c.step;
    inp.addEventListener('input', function () {
      var v = parseFloat(inp.value);
      if (isNaN(v)) return;
      if (c.clamp) v = Math.max(c.min, Math.min(c.max, v));
      state[c.key] = v;
      randeaza();
    });
    wrap.appendChild(inp);
    return wrap;
  }

  function campProsumer() {
    var wrap = el('div', 'tcoc-field');
    var lab = el('label', 'tcoc-label');
    lab.setAttribute('for', 'tcoc-prosumer');
    lab.appendChild(el('span', 'tcoc-label-text', 'Încărcare solară (prosumer)'));
    lab.appendChild(butonAjutor(wrap, 'Încărcare solară (prosumer)', D.TEXTE.prosumer));
    wrap.appendChild(lab);

    var linie = el('label', 'tcoc-toggle');
    var inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.id = 'tcoc-prosumer';
    inp.checked = state.prosumer;
    var txt = el('span', 'tcoc-toggle-text');
    function sincron() {
      txt.textContent = state.prosumer
        ? 'Pornit, încarci electric gratuit din solar'
        : 'Oprit, energie electrică la preț normal';
    }
    inp.addEventListener('change', function () {
      state.prosumer = inp.checked;
      sincron();
      randeaza();
    });
    sincron();
    linie.appendChild(inp);
    linie.appendChild(txt);
    wrap.appendChild(linie);
    return wrap;
  }

  function campSortare() {
    var wrap = el('div', 'tcoc-field');
    var lab = el('label', 'tcoc-label');
    lab.setAttribute('for', 'tcoc-sortare');
    lab.appendChild(el('span', 'tcoc-label-text', 'Sortează după'));
    wrap.appendChild(lab);

    var sel = document.createElement('select');
    sel.className = 'tcoc-input';
    sel.id = 'tcoc-sortare';
    [
      { v: 'total', t: 'Cost total' },
      { v: 'luna', t: 'Cost pe lună' },
      { v: 'km', t: 'Cost pe km' }
    ].forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o.v;
      opt.textContent = o.t;
      if (o.v === state.sortBy) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener('change', function () {
      state.sortBy = sel.value;
      randeaza();
    });
    wrap.appendChild(sel);
    return wrap;
  }

  function construiesteControale() {
    var gazda = root.querySelector('[data-tco-controls]');
    if (!gazda) return;
    gazda.innerHTML = '';

    var fs = el('fieldset', 'tcoc-grup');
    fs.appendChild(el('legend', 'tcoc-grup-titlu', 'Ipotezele tale'));
    var grid = el('div', 'tcoc-grid');
    GLOBALE.forEach(function (c) { grid.appendChild(campGlobal(c)); });
    grid.appendChild(campProsumer());
    grid.appendChild(campSortare());
    fs.appendChild(grid);
    gazda.appendChild(fs);

    var actiuni = el('div', 'tcoc-actiuni');
    var reset = el('button', 'tcoc-reset', 'Resetează cifrele');
    reset.type = 'button';
    reset.addEventListener('click', function () {
      state.kmAn = D.IPOTEZE.kmAn;
      state.ani = D.IPOTEZE.ani;
      state.eur = D.IPOTEZE.eur;
      state.prosumer = D.IPOTEZE.prosumer;
      state.sortBy = 'total';
      state.cars = D.PRESETS.map(clone);
      construiesteControale();
      construiesteMasini();
      randeaza();
    });
    actiuni.appendChild(reset);
    gazda.appendChild(actiuni);
  }

  /* ---------- editoarele pe mașină ---------- */

  function campMasina(i, key, eticheta, unit) {
    var wrap = el('div', 'tcoc-field');
    var lab = el('label', 'tcoc-label');
    lab.setAttribute('for', 'tcoc-car-' + i + '-' + key);
    lab.appendChild(el('span', 'tcoc-label-text', eticheta));
    if (unit) lab.appendChild(el('span', 'tcoc-unit', unit));
    wrap.appendChild(lab);

    var inp = document.createElement('input');
    inp.type = 'number';
    inp.className = 'tcoc-input';
    inp.id = 'tcoc-car-' + i + '-' + key;
    inp.value = state.cars[i].p[key];
    inp.min = 0;
    inp.step = 'any';
    inp.addEventListener('input', function () {
      var v = parseFloat(inp.value);
      if (isNaN(v)) v = 0;
      state.cars[i].p[key] = v;
      randeaza();
    });
    wrap.appendChild(inp);
    return wrap;
  }

  function grupuriMasina(car, i) {
    var energie;
    if (car.type === 'electric') {
      energie = [
        ['consum', 'Consum', 'kWh/100km'],
        ['pretEnergie', 'Preț energie', 'RON/kWh']
      ];
    } else if (car.type === 'phev') {
      energie = [
        ['consumElectric', 'Consum electric', 'kWh/100km'],
        ['pretElectric', 'Preț kWh', 'RON/kWh'],
        ['consum', 'Consum benzină', 'l/100km'],
        ['pretEnergie', 'Preț litru', 'RON/l'],
        ['ratioElectric', '% km în electric', '%']
      ];
    } else {
      energie = [
        ['consum', 'Consum', 'l/100km'],
        ['pretEnergie', 'Preț litru', 'RON/l']
      ];
    }
    return [
      { titlu: 'Achiziție și revânzare (EUR)', campuri: [
        ['pretAchizitie', 'Preț achiziție', 'EUR'],
        ['pretRevanzare', 'Revânzare estimată', 'EUR']
      ] },
      { titlu: 'Consum și energie', campuri: energie },
      { titlu: 'Costuri anuale fixe (RON / an)', campuri: [
        ['rcaAnual', 'RCA', 'RON/an'],
        ['cascoAnual', 'CASCO', 'RON/an'],
        ['rovinieta', 'Impozit + rovinietă', 'RON/an'],
        ['serviceAnual', 'Service + ITP', 'RON/an'],
        ['anvelope5ani', 'Anvelope (total 5 ani)', 'RON'],
        ['altele', 'Spălat, parcare', 'RON/an']
      ] }
    ];
  }

  function construiesteMasini() {
    var gazda = root.querySelector('[data-tco-cars]');
    if (!gazda) return;
    gazda.innerHTML = '';

    state.cars.forEach(function (car, i) {
      var det = document.createElement('details');
      det.className = 'tcoc-masina';
      if (i === 0) det.open = true;

      var sum = document.createElement('summary');
      sum.className = 'tcoc-masina-titlu';
      var dot = el('span', 'tcoc-dot');
      dot.style.background = car.color;
      sum.appendChild(dot);
      var nume = el('span', 'tcoc-masina-nume', car.name);
      nume.appendChild(el('small', null, car.sub));
      sum.appendChild(nume);
      var total = el('span', 'tcoc-masina-total');
      total.setAttribute('data-tco-car-total', String(i));
      sum.appendChild(total);
      det.appendChild(sum);

      var body = el('div', 'tcoc-masina-body');
      grupuriMasina(car, i).forEach(function (g) {
        var grup = el('div', 'tcoc-subgrup');
        grup.appendChild(el('p', 'tcoc-subgrup-titlu', g.titlu));
        var grid = el('div', 'tcoc-grid');
        g.campuri.forEach(function (c) {
          grid.appendChild(campMasina(i, c[0], c[1], c[2]));
        });
        grup.appendChild(grid);
        body.appendChild(grup);
      });
      det.appendChild(body);
      gazda.appendChild(det);
    });
  }

  /* ---------- randarea rezultatelor, în ancorele SSR ---------- */

  function randeaza() {
    var rezultate = M.ruleazaTot(state.cars, state);
    var ordonate = M.ordoneaza(rezultate, state.sortBy);
    var best = M.celMaiIeftin(rezultate);

    var tbody = root.querySelector('[data-tco-tbody]');
    if (tbody) {
      tbody.innerHTML = '';
      ordonate.forEach(function (r) {
        var tr = el('tr');
        if (r.index === best.index) tr.className = 'tcoc-best';
        var th = el('th', null, r.car.name + ', ' + r.car.sub);
        th.setAttribute('scope', 'row');
        if (r.index === best.index) th.appendChild(el('span', 'tcoc-badge', 'cel mai ieftin'));
        tr.appendChild(th);
        [
          M.TYPE_LABEL[r.car.type],
          ron(r.total) + ' RON',
          ron(r.perLuna) + ' RON',
          ron(r.perAn) + ' RON',
          nf1.format(r.perKm) + ' RON'
        ].forEach(function (v) { tr.appendChild(el('td', null, v)); });
        tbody.appendChild(tr);
      });
    }

    var cap = root.querySelector('[data-tco-caption]');
    if (cap) {
      cap.textContent = 'Cost total de deținere pe ' + aniTxt(state.ani) + ', la ' +
        nf0.format(state.kmAn) + ' km pe an și un curs de ' + nf2.format(state.eur) +
        ' lei pentru un euro.';
    }

    var teza = root.querySelector('[data-tco-teza]');
    if (teza) {
      teza.innerHTML = 'La ' + nf0.format(state.kmAn) + ' km pe an, ' + aniTxt(state.ani) +
        ' de deținere și un curs de ' + nf2.format(state.eur) + ' lei pentru un euro, ' +
        'cea mai ieftină mașină din comparație este <strong>' + esc(best.car.name) + ', ' +
        esc(best.car.sub) + '</strong>: ' + ron(best.perLuna) + ' RON pe lună, adică ' +
        ron(best.total) + ' RON în total și ' + nf1.format(best.perKm) + ' RON pe kilometru.';
    }

    var desf = root.querySelector('[data-tco-desfasurare]');
    if (desf) {
      var suma = best.total || 1;
      desf.textContent = 'La ' + best.car.name + ', cei ' + ron(best.total) +
        ' RON se împart astfel: ' +
        M.CATEGORII.map(function (cat) {
          var v = Math.max(0, best[cat.key]);
          return cat.label + ' ' + ron(v) + ' RON (' + Math.round(v / suma * 100) + '%)';
        }).join(', ') + '.';
    }

    var pros = root.querySelector('[data-tco-prosumator]');
    if (pros) {
      var ipOff = { kmAn: state.kmAn, ani: state.ani, eur: state.eur, prosumer: false };
      var ipOn = { kmAn: state.kmAn, ani: state.ani, eur: state.eur, prosumer: true };
      var parti = [];
      state.cars.forEach(function (car) {
        var off = M.calc(car, ipOff).total;
        var on = M.calc(car, ipOn).total;
        if (on < off) parti.push(car.name + ' de la ' + ron(off) + ' la ' + ron(on) + ' RON');
      });
      pros.textContent = 'Dacă încarci din panouri fotovoltaice, costul energiei electrice ' +
        'devine 0 la mașinile electrice și la partea electrică a PHEV. Benzina și motorina ' +
        'nu sunt afectate. Pe toată perioada, asta înseamnă: ' + parti.join(', ') + '.';
    }

    rezultate.forEach(function (r) {
      var t = root.querySelector('[data-tco-car-total="' + r.index + '"]');
      if (t) t.textContent = ron(r.perLuna) + ' RON/lună · ' + ron(r.total) + ' RON';
    });
  }

  /* ---------- verificare de paritate SSR vs JS ---------- */

  function verificaParitate() {
    var ssrTeza = root.querySelector('[data-tco-teza]');
    if (!ssrTeza) return;
    var inainte = ssrTeza.textContent.replace(/\s+/g, ' ').trim();
    randeaza();
    var dupa = ssrTeza.textContent.replace(/\s+/g, ' ').trim();
    if (inainte !== dupa && window.console && console.warn) {
      console.warn(
        '[calculator-tco] Tabelul server-side diferă de recalculul din browser. ' +
        'Rulează "node tools/build-ssr.mjs" și dă push, altfel HTML-ul indexat rămâne pe cifre vechi.'
      );
    }
  }

  construiesteControale();
  construiesteMasini();
  verificaParitate();
})();
